import { useState, useEffect, useCallback } from 'react';
import { DailyUptimeCounter } from './dailyUptimeCounter';
import { UsesCounter } from './usesCounter';
import { UnitActivityChart } from '../unitActivityChart';
import { PieChart } from './pieChart';

export const DashboardBanner = ({ 
  totalDailyUptime, 
  totalDailyUses,
  activeUnitsCount,
  activeUnitsWithErrors,
  activeUnitsWithoutErrors,
  disabledUnitsCount,
  disconnectedUnitsCount,
  totalUnitsCount
}) => {
  const [unitChart, setUnitChart] = useState([
    { type: 'Active', amount: 0, color: '#2FD5CB' },
    { type: 'Disabled', amount: 0, color: '#FC664E' },
  ]);

  const [pieChartData, setPieChartData] = useState([
    { type: 'Active with Errors', amount: 0, color: '#FC664E' },
    { type: 'Active without Errors', amount: 0, color: '#2FD5CB' },
    { type: 'Disabled', amount: 0, color: '#9B9B9B' },
    { type: 'Disconnected', amount: 0, color: '#FFA500' },
  ]);

  // units chart update
  const updateUnitChartData = useCallback(() => {
    setUnitChart([
      { type: 'Active', amount: activeUnitsCount || 0, color: '#2FD5CB' },
      { type: 'Disabled', amount: disabledUnitsCount || 0, color: '#FC664E' },
    ]);
  }, [activeUnitsCount, disabledUnitsCount]);

  // pie chart update - now shows all unit categories
  const updatePieChartData = useCallback(() => {
    setPieChartData([
      { type: 'Active with Errors', amount: activeUnitsWithErrors || 0, color: '#FC664E' },
      { type: 'Active without Errors', amount: activeUnitsWithoutErrors || 0, color: '#2FD5CB' },
      { type: 'Disabled', amount: disabledUnitsCount || 0, color: '#9B9B9B' },
      { type: 'Disconnected', amount: disconnectedUnitsCount || 0, color: '#FFA500' },
    ]);
  }, [activeUnitsWithErrors, activeUnitsWithoutErrors, disabledUnitsCount, disconnectedUnitsCount]);

  // charts update
  useEffect(() => {
    updatePieChartData();
    updateUnitChartData();
  }, [updatePieChartData, updateUnitChartData]);

  return (
    <div className="row d-flex align-items-stretch pb-4">
      <div className="col-2">
        <DailyUptimeCounter inputData={totalDailyUptime} />
      </div>
      <div className="col-3">
        <UsesCounter inputData={totalDailyUses} />
      </div>
      <div className="col-3">
        <UnitActivityChart inputData={unitChart} totalUnitsCount={totalUnitsCount} />
      </div>
      <div className="col-4 pie-chart-container">
        <PieChart inputData={pieChartData} />
      </div>
    </div>
  );
};